import React, { useEffect } from "react";
import Header from "../../../sharedScreens/Header";
import SideMenu from "../../../sharedScreens/menuItems/SideMenu";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { UtilService } from "../../../services/shared/UtilService";
import { msgTypes } from "../../../constants/msgTypes";
import TopAirlinesBarGraph from "../../../modules/dashboard/components/TopAirlinesBarGraph";
import StatCard from "../../../modules/dashboard/components/StatCard";
import BookingChart from "../../../modules/dashboard/components/BookingChart";
import RecentPayments from "../../../modules/dashboard/components/RecentPayments";
import TopCorporates from "../../../modules/dashboard/components/TopCorporates";
import UpcomingTravel from "../../../modules/dashboard/components/UpcomingTravel";
import DashboardFlightCard from "../../../modules/dashboard/components/DashboardFlightCard";
import DashboardRecentBooking from "../../../modules/dashboard/components/DashboardRecentBooking";
import { useGlobalState } from "../../../services/context/AuthContext";
import { Role } from "../../../constants/enum";
import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined";
import Slider from "react-slick";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";

import "./Dashboard.scss";
import { MuiInput } from "../../../components/basicComponent/MuiInput";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";

function Dashboard() {
  const { userInfo } = useGlobalState();
  const navigate = useNavigate();

  const sampleFlights = [
    {
      id: 1,
      imageUrl:
        "https://images.pexels.com/photos/358220/pexels-photo-358220.jpeg?auto=compress&cs=tinysrgb&w=600",
      origin: "New York",
      destination: "London",
      flightType: "Direct Flight" as const,
      duration: "7h 45m",
      stops: "Non-stop",
      currentPrice: 850,
      originalPrice: 1050,
      currency: userInfo?.currencyCode || "AED",
    },
    {
      id: 2,
      imageUrl:
        "https://images.pexels.com/photos/2026324/pexels-photo-2026324.jpeg?auto=compress&cs=tinysrgb&w=600",
      origin: "Paris",
      destination: "Tokyo",
      flightType: "One Stop" as const,
      duration: "14h 20m",
      stops: "1 stop",
      currentPrice: 1200,
      originalPrice: 1450,
      currency: userInfo?.currencyCode || "AED",
    },
    {
      id: 3,
      imageUrl:
        "https://images.pexels.com/photos/2026324/pexels-photo-2026324.jpeg?auto=compress&cs=tinysrgb&w=600",
      origin: "Paris",
      destination: "Tokyo",
      flightType: "One Stop" as const,
      duration: "14h 20m",
      stops: "1 stop",
      currentPrice: 1200,
      originalPrice: 1450,
      currency: userInfo?.currencyCode || "AED",
    },
    {
      id: 4,
      imageUrl:
        "https://images.pexels.com/photos/2026324/pexels-photo-2026324.jpeg?auto=compress&cs=tinysrgb&w=600",
      origin: "Paris",
      destination: "Tokyo",
      flightType: "One Stop" as const,
      duration: "14h 20m",
      stops: "1 stop",
      currentPrice: 1200,
      originalPrice: 1450,
      currency: userInfo?.currencyCode || "AED",
    },
  ];

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 1000,
    arrows: false,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const isCorporate =
    userInfo?.roleName === Role.ADMIN ||
    userInfo?.roleName === Role.CORPORATE_USER;

  const isUser = userInfo?.roleName === Role.CORPORATE_USER;

  const isSuperAdmin = userInfo?.roleName === Role.SUPER_ADMIN;
  const isCorporateAdmin = userInfo?.roleName === Role.ADMIN;

  const [dashboardData, setDashboardData] = React.useState<any>(null);

  useEffect(() => {
    getDashboardData();
  }, []);

  const getDashboardData = async () => {
    try {
      let response;

      if (isSuperAdmin) {
        response = await UtilService.getDashboardAnalyticsForSuperAdmin();
      } else if (isCorporate) {
        response = await UtilService.getDashboardAnalyticsForCorporate();
      }

      if (response?.statusMsg === msgTypes.SUCCESS.msg) {
        setDashboardData(response.data);
      } else {
        setDashboardData(null);
      }
    } catch (error) {
      console.error("Error fetching dashboard analytics:", error);
      setDashboardData(null);
    }
  };

  const totalBookings = dashboardData?.overview?.total_bookings?.value || 0;
  const totalRevenue = dashboardData?.overview?.total_revenue?.value || 0;
  const totalClients = dashboardData?.overview?.total_clients?.value || 0;
  const bookingFailed = dashboardData?.overview?.failed_bookings?.value || 0;
  const bookingTrends = dashboardData?.booking_trends || [];

  const topAirlines = dashboardData?.top_airlines || [];
  const recentPayments = dashboardData?.recent_payments || [];
  const topCorporates = dashboardData?.top_corporates || [];
  const upcomingTravel = dashboardData?.upcoming_travels || [];
  const topDestinations = dashboardData?.top_destinations || [];
  const recentBookings = dashboardData?.recent_bookings || [];

  return (
    <>
      <div className="">
        <SideMenu />
        <div className="wrapper flex grow flex-col">
          <Header />
          <main className="grow content" id="content" role="content">
            <div className="container-fixed">
              {/* Overview - Common for both SuperAdmin & Corporate */}
              <div className="row g-3">
                <StatCard
                  title="Total Booking"
                  value={totalBookings}
                  valueColor="text-info"
                  imgClass={"media/images/booking.png"}
                />
                <StatCard
                  title="Total Revenue"
                  value={`${userInfo?.currencyCode ?? "AED"} ${totalRevenue}`}
                  valueColor="text-success"
                  imgClass="media/images/revenue.png"
                />
                {(isSuperAdmin || isCorporateAdmin) && (
                  <StatCard
                    title="Total Users"
                    valueColor="text-primary"
                    value={totalClients}
                    imgClass="media/images/clients.png"
                  />
                )}

                {isUser && (
                  <StatCard
                    title="Hotel Booking"
                    valueColor="text-primary"
                    value={totalClients}
                    imgClass="media/images/clients.png"
                  />
                )}

                <StatCard
                  title="Booking Failed"
                  valueColor="text-danger"
                  value={bookingFailed}
                  imgClass="media/images/failed.png"
                />
              </div>

              {/* Super Admin Only Section */}
              {isSuperAdmin && (
                <>
                  <div className="row mt-3">
                    <div className="col-xl-4  col-sm-6  ">
                      <BookingChart data={bookingTrends} />
                    </div>
                    <div className="col-xl-4  col-sm-6 mt-3 mt-sm-0">
                      <TopAirlinesBarGraph data={topAirlines} />
                    </div>

                    <div className="col-xl-4  col-sm-6 mt-3 mt-xl-0">
                      <div className="card">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="card-body">
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                                "& .MuiDateCalendar-root": {
                                  width: "100%", // mobile पर full width
                                  maxWidth: 400, // desktop पर max width
                                },
                              }}
                            >
                              <DateCalendar />
                            </Box>
                          </div>
                        </LocalizationProvider>
                      </div>
                    </div>

                    <div className="col-xl-4 col-sm-6 mt-3">
                      <TopCorporates
                        height={"kjh"}
                        corporates={topCorporates}
                      />
                    </div>

                    <div className="col-xl-4 col-sm-6 mt-3">
                      <RecentPayments payments={recentPayments} />
                    </div>

                    <div className="col-xl-4 col-sm-6 mt-3">
                      <UpcomingTravel data={upcomingTravel} height={""} />
                    </div>
                  </div>

                  {/* Top Destinations */}
                  <div className="row">
                    <div className="col-md-12 mt-3">
                      <div className="border-0 shadow-sm card">
                        <div className=" card-header dashboard-card-header">
                          <h6 className="mb-0 fw-semibold">Top Destinations</h6>
                          <button
                            type="button"
                            className="text-decoration-none btn btn-link btn-sm veiw-all-btn"
                          >
                            View All
                            <ArrowOutwardOutlinedIcon sx={{ fontSize: 16 }} />
                          </button>
                        </div>
                        <div className="card-body g-3 row">
                          <div className="slider-container">
                            <Slider {...settings}>
                              {sampleFlights?.map((flight, index) => (
                                <div key={index}>
                                  <DashboardFlightCard
                                    key={index}
                                    imageUrl={flight.imageUrl}
                                    origin={flight.origin}
                                    destination={flight.destination}
                                    flightType={flight.flightType}
                                    duration={flight.duration}
                                    stops={flight.stops}
                                    currentPrice={flight.currentPrice}
                                    originalPrice={flight.originalPrice}
                                    currency={flight.currency}
                                    onBook={() => {}}
                                  />
                                </div>
                              ))}
                            </Slider>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {isCorporate && (
                <div className="row mt-3">
                  <div className="col-md-6 mb-3 mb-lg-0">
                    <BookingChart data={bookingTrends} />
                  </div>

                  <div className="col-md-6">
                    <UpcomingTravel data={upcomingTravel} height={50} />
                  </div>
                </div>
              )}

              {/* Recent Bookings - Common */}
              <div className="row">
                <div className="col-md-12 my-3">
                  <div className="card ">
                    <div className="card-header bg-white border-0 dashboard-card-header">
                      <h6 className="mb-0 fw-semibold">Recent Bookings</h6>
                      <div className="d-flex justify-content-end">
                        {/* <div className=" hotel-search-input  me-4">
                          <MuiInput
                            iconEnd={<SearchIcon />}
                            placeholder="Search here....."
                          />
                        </div> */}
                        <button
                          type="button"
                          className="text-decoration-none btn btn-link btn-sm veiw-all-btn"
                          onClick={() => {
                            navigate("/flightbookinghistory");
                          }}
                        >
                          <Link to="/flightbookinghistory?tab=0">View All</Link>
                          <ArrowOutwardOutlinedIcon sx={{ fontSize: 16 }} />
                        </button>
                      </div>
                    </div>
                    <DashboardRecentBooking data={recentBookings} />
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
